var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsEnum, IsString } from 'class-validator';
import { CaregiverRelationship } from '../user/enums/caregiver.enum.js';
/** Query parameter that names the caregiver entry on cookie-authenticated media URLs (#1841). */
export const CAREGIVER_ID_QUERY_PARAM = 'caregiverId';
/**
 * The caregiver entry a request acts through (#1841, ADR-0042). The request's
 * subject is the patient's Person; this rides along as the actor. Every act is
 * recorded as the patient's own, so nothing but the consent declaration reads
 * it, and Account-level acts apply to {@link accountId}, never the patient's.
 */
export class CaregiverContextDto {
    entryId;
    /** The caregiver's own Account (`sub`). */
    accountId;
    /** The caregiver's name on the entry. */
    name;
    relationship;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CaregiverContextDto.prototype, "entryId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CaregiverContextDto.prototype, "accountId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CaregiverContextDto.prototype, "name", void 0);
__decorate([
    Expose(),
    IsEnum(CaregiverRelationship),
    __metadata("design:type", String)
], CaregiverContextDto.prototype, "relationship", void 0);
//# sourceMappingURL=caregiver-context.js.map